"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ComponentProps } from "react";

export function ThemeProvider({ children, ...props }: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="data-theme"
      defaultTheme="light"
      // Tek tema (Orhan, 2026-09-30): açık/koyu seçimi kaldırıldı. Header ve üst şerit
      // `data-theme="dark"` koyu adası (globals.css); önceden seçilmiş koyu tercih yok sayılır.
      forcedTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
